import { getGetViewerQueryKey, useGetViewer } from "@/api/generated/hooks/auth/auth";
import type { Viewer } from "@/api/generated/types";
import { isApiError } from "@/api/lib/fetcher";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { setStoredAuthToken } from "./auth-token";

export function useViewerQuery() {
  return useGetViewer({
    query: {
      retry: false,
      select: (response) => response.data as Viewer,
    },
  });
}

export function useRequireOperator() {
  const navigate = useNavigate();
  const viewerQuery = useViewerQuery();

  useEffect(() => {
    if (viewerQuery.isError && isApiError(viewerQuery.error) && viewerQuery.error.status === 401) {
      setStoredAuthToken(null);
      void navigate({ to: "/a" });
      return;
    }

    if (viewerQuery.data && viewerQuery.data.role !== "operator") {
      void navigate({ to: "/a" });
    }
  }, [navigate, viewerQuery.data, viewerQuery.error, viewerQuery.isError]);

  return viewerQuery;
}

export function useClearViewer() {
  const queryClient = useQueryClient();

  return () => {
    setStoredAuthToken(null);
    void queryClient.invalidateQueries({ queryKey: getGetViewerQueryKey() });
  };
}

export function isOperator(viewer: Viewer | null | undefined): boolean {
  return viewer?.role === "operator";
}
